const STORAGE_KEY = 'cariListLaunch';

/** @typedef {{ mode: 'yeniAtama' | 'atamaBos' | 'ilgiIsteyen' }} CariListLaunch */

/** @returns {CariListLaunch | null} */
export function readCariListLaunch() {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (
      parsed?.mode === 'yeniAtama'
      || parsed?.mode === 'atamaBos'
      || parsed?.mode === 'ilgiIsteyen'
    ) {
      return parsed;
    }
  } catch (_) { /* ignore */ }
  return null;
}

/** @param {CariListLaunch} launch */
export function setCariListLaunch(launch) {
  try {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(launch));
    window.dispatchEvent(new CustomEvent('cari-list-launch', { detail: launch }));
  } catch (_) { /* ignore */ }
}

export function clearCariListLaunch() {
  try {
    sessionStorage.removeItem(STORAGE_KEY);
  } catch (_) { /* ignore */ }
}
